import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialQuestClickShowMe = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (nextTutorialStepConfig.focusId == undefined) {
        return undefined;
    }
    var isNewQuestShowMe = tutorialStepConfig.nextStep === IdTutorialStep.checkNewQuest_clickShowMeButton &&
        nextTutorialStepConfig.focusId === IdTutorialFocusElement.quest_show_me;
    var isCollectQuestCollectRewards = tutorialStepConfig.nextStep === IdTutorialStep.collectQuestReward_clickCollectRewards &&
        nextTutorialStepConfig.focusId === IdTutorialFocusElement.quest_collect;
    if (!isNewQuestShowMe && !isCollectQuestCollectRewards) {
        return undefined;
    }
    return path;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialQuestClickShowMe.ts
// module id = 2485
// module chunks = 3